/**
 * Local dev login coordinator — stable OAuth on 8122 (via gateway 5173 or direct).
 * Product API traffic stays on per-stack VITE_API_ORIGIN.
 */
export function hubDevCoordinatorApiBase(): string {
  if (!import.meta.env.DEV || typeof window === "undefined") {
    return "";
  }
  const { hostname, port } = window.location;
  if (hostname !== "localhost" && hostname !== "127.0.0.1") {
    return "";
  }
  // Gateway shell — OAuth paths proxy to coordinator on 8122.
  if (port === "5173" || port === "") {
    return "";
  }
  // Internal UI port (5175, 5176, …) — use gateway so OAuth stays on coordinator.
  return "https://localhost:5173";
}
